import {
  PapiComment,
  PapiDeviation,
  PapiUser,
  PapiDeviationPoll,
  PapiForum,
  PapiDeviationStatus,
  PapiDeviationCommission,
  PapiGallection,
} from '@wix/da-types-papi';

export interface CommentSubject {
  poll?: PapiDeviationPoll;
  forum?: PapiForum;
  profile?: PapiUser;
  status?: PapiDeviationStatus;
  comment?: PapiComment;
  deviation?: PapiDeviation;
  commission?: PapiDeviationCommission;
  collection?: PapiGallection;
}

export enum SubjectType {
  POLL = 'poll',
  FORUM = 'forum',
  STATUS = 'status',
  PROFILE = 'profile',
  COMMENT = 'comment',
  DEVIATION = 'deviation',
  GROUPNOTE = 'groupnote',
  COLLECTION = 'collection',
  COMMISSION = 'commission',
}
